import {
  completeApplicantStep,
  setRequestIdentifier,
  setStepApplicantEdited,
} from "../../../../../../store/redux/slice/Forms/seRecognitionForm";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createSEApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { initialSERecApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { ApplicationSubtype } from "@duosoftbg/nacid-components";
import SecondaryEduApplicantDetailsForm from "../../../common/form/applicant/SecondaryEduApplicantDetailsForm";

const SERecognitionStepApplicant = () => {
  const seRecognitionForm = useAppSelector((state) => {
    return state.Forms.SERecognitionForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    seRecognitionForm,
    baseEndpointPaths.seRecognition,
    createSEApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialSERecApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seRecognitionForm.applicantDetails, methods.reset);

  return <SecondaryEduApplicantDetailsForm methods={methods} onSubmit={onSubmit} hasRepresentativeCompany={true} />;
};
export default SERecognitionStepApplicant;
